"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jfdSmt = void 0;
const jfd_type10_1 = require("./jfd.type10");
exports.jfdSmt = {
    fields: {
        NCICDesignationCode: {
            ...jfd_type10_1.type10Fields.NCICDesignationCode
        },
        SMT: {
            ...jfd_type10_1.ncicCodeFields.SMT
        },
        SMTDescriptors: {
            ...jfd_type10_1.type10Fields.SMTDescriptors
        }
    },
    rules: [jfd_type10_1.smtLocationToNcicCode],
    onImport: [jfd_type10_1.ncicCodeToTypeAndLocation]
};
//# sourceMappingURL=jfd-smt-type10.js.map